import { Dispatch } from 'redux';

import backend from '../../../apis/backend';
import { ReduxState } from '../../state';
import {
  Location as ILocation,
} from '../types';
import { 
  createLocationSuccess,
  createLocationFailure,
  selectLocation, 
} from '../actions';
import { asyncSetDefaultLocation } from './asyncSetDefaultLocation';

// Initiator for creating a new location
export const asyncLocationCreate = (newLocation: ILocation, makeDefault: boolean) => {
  return async (dispatch: Dispatch | any, getState: () => ReduxState) => {
    const { pageOrderFlow } = getState().page;
    try {
      const { auth } = getState();
      const loginToken = auth.loginToken;

      const headers = {
        'X-Auth-Token': loginToken,
      };

      const response = await backend.post('/user-service/api/v1/locations', newLocation, { headers });

      if (response.status === 201) {
        const createdLocation: ILocation = response.data;
        dispatch(createLocationSuccess(createdLocation));
        dispatch(selectLocation(createdLocation))
        if (makeDefault && createdLocation && createdLocation._id) {
          dispatch(asyncSetDefaultLocation(createdLocation._id))
        }
      } else {
        dispatch(createLocationFailure('Failed to create a new user location.'));
      }
    } catch (error) {
      console.error('Failed to create a new user location:', error);
      dispatch(createLocationFailure('An error occurred while creating a new user location.'));
    }
  };
};